import gsap from 'gsap';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import InterfaceCanvas from '../_app/cuchillo/layout/InterfaceCanvas';
import BGImage from '../layout/BGImage';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';

export default class Photos extends Default {
  timeline;
  projects;

  calls = {
    hover: (e) => this.hover(e.target),
    out: (e) => this.out(e.target),
    // loop: () => this.loop()
  }

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();
    this.isEnabled = false;
    this.projects = [...GetBy.class('__project')];
    BGImage.hide();
    this.setupAnimation();
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.directShow();
      Preloader.hide(() => { this.showList() });
    } else {
      Wrap.directShow();
      this.showList();
    }
  }

  showList() {
    this.timeline.restart();
    this.isEnabled = true;
    this.afterShow();
  }

  afterShow() {
    super.afterShow();
  }

  setupAnimation() {
    this.timeline = gsap.timeline({ paused: true });
    let delay = 0;

    this.projects.map(project => {
      this.timeline.from(project, {
        alpha: 0,
        duration: .1,
        force3D: true
      }, delay);
      delay += .08;

      project.addEventListener(Basics.mouseOver, this.calls.hover);
      //project.addEventListener(Basics.mouseOut, this.calls.out);
    });
  }

  hover(target) {
    if (isMobile || !this.isEnabled) return;

    clearTimeout(this.idTimerOut);
    BGImage.play(target.getAttribute('data-hover-image'));
  }

  out() {
    if (isMobile) return;
    
    this.idTimerOut = setTimeout(() => {
      BGImage.hide();
    }, 150);
  }

  dispose() {
    clearTimeout(this.idTimerOut);

    BGImage.hide();

    this.projects.map(project => {
      project.removeEventListener(Basics.mouseOver, this.calls.hover);
      //project.removeEventListener(Basics.mouseOut, this.calls.out);
    });
  }
}

ControllerPage._addPage("page-photos", Photos)
